<template>
  <ul>
    <li v-for="(group, groupIndex) in groups" v-bind:key="groupIndex" :class="{active: group === activeGroup}"
      @click="setActiveGroup(group === activeGroup ? null : group)">
      <span>{{ group.displayName.replace('Team', '') }}</span>
    </li>
  </ul>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'activeGroup'
    ])
  },
  methods: {
    setActiveGroup(group) {
      this.$store.commit('activeGroup', group)
    },
  }
}
</script>
<style scoped>
ul {
  display: flex;
  margin: 2rem 0;
  padding: 0;
  position: relative;
  z-index: 25;
}
ul::before,
ul::after {
  align-self: flex-end;
  background-color: rgba(22,0,43,.1);
  content: '';
  flex: 0 0 32rem;
  height: .1rem;
  margin-bottom: -.1rem;
  opacity: .5;
}
ul::after {
  flex: 1;
}
li {
  border: solid .1rem rgba(22,0,43,.1);
  border-radius: 1rem 1rem 0 0;
  cursor: pointer;
  list-style: none;
  margin: 0 -.1rem -.1rem 0;
  opacity: .5;
  padding: 1rem 2rem;
}
li.active {
  border: solid .1rem rgba(22,0,43,.3);
  border-bottom: none;
  font-weight: bold;
  opacity: .8;
}
</style>
